<template>
    <div class="componentRoot">
        <v-container fluid v-if="loaded">
            <v-row>
                <v-col cols="12">
                    <RouterView />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "calendarRoot",

    props: [
    ],

    data() {
        return {
            loaded: false
        };
    },

    components: {
    },

    watch: {

    },

    computed: {
    },

    methods: {
    },

    mounted() {
        localStorage.setItem("date", "")

        this.loaded = true
    }

};
</script>
